import React from 'react';

const LABELS = {
  proposal: 'Proposal',
  invoice: 'Invoice',
  purchase_order: 'Purchase Order',
};

export default function HeaderSection({ proposalNumber, title, onClose, docType = 'proposal' }) {
  const label = LABELS[docType] || 'Document';

  return (
    <div className="doc-header">
      <h1>
        {label} <span className="doc-number">{proposalNumber}</span>
        {title && <span className="doc-title-name"> · {title}</span>}
      </h1>

      <button className="doc-back" onClick={onClose}>
        ← Back
      </button>
    </div>
  );
}
